import {RootState} from "../../setup/typedefs";

export const notificationsSelector = (state: RootState) => state.notifications.data;
